import script from "./FeedPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedPage.vue?vue&type=script&setup=true&lang=js"

import "./FeedPage.vue?vue&type=style&index=0&id=762c2a52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-762c2a52"]])

export default __exports__